<template>
  <div>
    <el-dialog title="选择商品" :visible="show" width="1000px" @close="close">
      <el-form inline :model="searchData">
        <el-form-item>
          <el-input
            placeholder="名称/颜色/单位/规格/条码"
            clearable
            prefix-icon="el-icon-search"
            v-model="searchData.searchInputValue"
            style="width: 250px"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="商品分类">
          <CommodityCategoryAvailableSelect
            v-model="searchData.commodityCategoryIdList"
            @change="changeAndSearch"
          ></CommodityCategoryAvailableSelect>
        </el-form-item>
        <el-form-item label="在产状态">
          <EnumSelect
            enumName="CommodityProductionStatusEnum"
            placeholder="请选择商品在产状态"
            v-model="searchData.productionStatusEnumList"
            @change="changeAndSearch"
          ></EnumSelect>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            size="mini"
            @click="changeAndSearch"
            :loading="searchLoading"
          >
            查询
          </el-button>
          <el-button
            icon="el-icon-refresh"
            size="mini"
            @click="resetAndSearch"
            :loading="searchLoading"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="searchLoading"
        :data="searchRes && searchRes.data ? searchRes.data : []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        ref="refsTable"
        @sort-change="sortChange"
        max-height="500px"
      >
        <el-table-column
          label="商品图片"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <CommodityImage :commodity="scope.row"></CommodityImage>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          min-width="150"
          align="left"
          header-align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <div class="fm-line-3">
              {{ scope.row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="productionStatusEnum.Desc"
          label="在产状态"
          width="150"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <span
              v-fmtype="
                $jsTool.getCommodityProductionType(
                  scope.row.productionStatusEnum
                )
              "
              >{{ scope.row.productionStatusEnum.Desc }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="commodityCategory.name"
          label="商品信息"
          width="250"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div>分类：{{ scope.row.commodityCategory.name }}</div>
            <div>颜色：{{ scope.row.color }}</div>
            <div>单位：{{ scope.row.unit }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="零售价"
          width="150"
          align="left"
          header-align="center"
          show-overflow-tooltip
          v-if="from == 'SaleOrder'"
        >
          <template slot-scope="scope">
            <fm-amount
              slot="right"
              :bold="false"
              size="0.8rem"
              :amount="scope.row.minBuyingPrice"
              :nextAmount="scope.row.maxBuyingPrice"
            ></fm-amount>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="selectCommodity(scope.row)"
              type="text"
              icon="el-icon-document"
            >
              选择商品
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="searchRes && searchRes.pageInfo"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchRes.pageInfo.page"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="searchRes.pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchRes.total"
      >
      </el-pagination>
    </el-dialog>
    <el-dialog
      id="selectCommodityPopup"
      title="选择规格/套装"
      :visible="selectCommodityPopupShow"
      width="600px"
      @close="selectCommodityPopupShow = false"
    >
      <el-row>
        <el-col :span="3">
          <CommodityImage
            :commodity="nowCommodity"
            :commoditySpec="nowCommoditySpec"
            size="60px"
          >
          </CommodityImage>
        </el-col>
        <el-col :span="20">
          <p>
            商品：<span style="font-weight: bold">{{ nowCommodity.name }}</span>
          </p>
          <p>
            <span v-fmtype="popupSubTitle.type">{{ popupSubTitle.title }}</span
            ><span
              v-fmtype="popupSubTitle.type"
              style="font-weight: bold"
              v-if="popupSubTitle.text"
              >{{ popupSubTitle.text }}</span
            >
          </p>
        </el-col>
      </el-row>
      <div
        v-if="from != 'CommodityLossOrder' && from != 'CommodityTransferOrder'"
      >
        <el-divider></el-divider>
        <div class="fm-subtitle" style="color: var(--fm-primary-text-color)">
          销售套装{{ " (" + (canSelectSaleSuitList.length || "暂无") + ")" }}
        </div>
        <div
          style="
            min-height: 20px;
            max-height: 200px;
            overflow-y: auto;
            display: flex;
            flex-flow: row wrap;
          "
        >
          <el-tag
            v-for="(item, index) in canSelectSaleSuitList"
            :key="'saleSuit' + index"
            :effect="
              nowSaleSuit && nowSaleSuit.id == item.id ? 'dark' : 'light'
            "
            :type="
              nowSaleSuit && nowSaleSuit.id == item.id ? 'primary' : item.type
            "
            class="fm-margin-right-10 fm-margin-top-10 fm-pointer"
            style="max-width: 100%"
            @click="clickSaleSuitTag(item)"
            >{{ item.label }}</el-tag
          >
        </div>
        <div class="fm-mt-10" v-fmtype="'info'" v-if="nowSaleSuit">
          {{ "所选套装内容：" + nowSaleSuit.desc }}
        </div>
      </div>
      <el-divider></el-divider>
      <div class="fm-subtitle" style="color: var(--fm-primary-text-color)">
        规格{{ " (" + (canSelectSpecList.length || "暂无") + ")" }}
      </div>
      <div
        style="
          min-height: 20px;
          max-height: 200px;
          overflow-y: auto;
          display: flex;
          flex-flow: row wrap;
        "
      >
        <el-tag
          v-for="(item, index) in canSelectSpecList"
          :key="'saleSuit' + index"
          :effect="
            nowCommoditySpec && nowCommoditySpec.id == item.id
              ? 'dark'
              : 'light'
          "
          :type="
            nowCommoditySpec && nowCommoditySpec.id == item.id
              ? 'primary'
              : item.type
          "
          class="fm-margin-right-10 fm-margin-top-10 fm-pointer"
          style="max-width: 100%"
          @click="clickCommoditySpecTag(item)"
        >
          <div class="fm-flex">
            <CommodityImage
              class="fm-mr-5"
              :emptyShow="false"
              :commoditySpec="item"
              size="1.5em"
            ></CommodityImage>
            {{ item.label }}
          </div>
        </el-tag>
      </div>

      <el-divider></el-divider>
      <el-row v-if="from == 'SaleOrder'">
        <el-tooltip effect="dark" content="" placement="top-start">
          <div slot="content" style="line-height: 1.5em">
            <div style="font-weight: bold">数量说明</div>
            若商品规格已停产，则销售数量不得大于规格的可用库存<br />若在产则仅提示可用库存(现货数量)，并可超量预售
          </div>
          <i class="el-icon el-icon-question fm-mr-5"></i>
        </el-tooltip>

        <span class="fm-mr-10" style="color: var(--fm-primary-text-color)"
          >购买数量</span
        >
        <CommodityQuantityInputBox
          v-model="nowQuantity"
          label="数量"
          size="small"
          :max="
            nowCommoditySpec && !nowCommoditySpec.inProduction
              ? nowCommoditySpec.availableQuantity
              : 1000
          "
          @change="
            (e) => {
              changeItemQuantityFromList(e, {
                commoditySpecId: nowCommoditySpec.id,
              });
            }
          "
          v-if="
            (nowCommoditySpec && nowCommoditySpec.inProduction) ||
            (nowCommoditySpec &&
              !nowCommoditySpec.inProduction &&
              nowCommoditySpec.availableQuantity > 0)
          "
        ></CommodityQuantityInputBox>
        <CommodityQuantityInputBox
          v-model="nowQuantity"
          label="数量"
          size="small"
          :max="
            nowSaleSuit && nowSaleSuit.someNotInProduction
              ? nowSaleSuit.maxSelectCount
              : 1000
          "
          @change="
            (e) => {
              changeItemQuantityFromList(e, { saleSuitId: nowSaleSuit.id });
            }
          "
          v-if="nowSaleSuit"
        ></CommodityQuantityInputBox>
        <template v-if="nowCommoditySpec">
          <span
            class="fm-ml-5"
            v-fmtype="'info'"
            style="font-size: 0.8rem"
            v-if="nowCommoditySpec.inProduction"
            >{{ "现货 " + nowCommoditySpec.availableQuantity + " 件" }}</span
          >
          <span
            class="fm-ml-5"
            v-fmtype="'warning'"
            style="font-size: 0.8rem"
            v-if="
              !nowCommoditySpec.inProduction &&
              nowCommoditySpec.availableQuantity > 0
            "
            >{{
              "最多可卖 " + nowCommoditySpec.availableQuantity + " 件"
            }}</span
          >
          <span
            class="fm-ml-5"
            v-fmtype="'warning'"
            style="font-size: 0.8rem"
            v-if="
              !nowCommoditySpec.inProduction &&
              nowCommoditySpec.availableQuantity <= 0
            "
            >当前规格已停产且已售空</span
          >
        </template>
        <template v-if="nowSaleSuit">
          <span
            class="fm-ml-5"
            v-fmtype="'info'"
            style="font-size: 0.8rem"
            v-if="!nowSaleSuit.someNotInProduction"
            >{{ "现货 " + nowSaleSuit.maxSelectCount + " 套" }}</span
          >
          <span
            class="fm-ml-5"
            v-fmtype="'warning'"
            style="font-size: 0.8rem"
            v-else
            >{{ "最多可卖 " + nowSaleSuit.maxSelectCount + " 套" }}</span
          >
        </template>
      </el-row>
      <el-row v-if="from == 'PurchaseOrder'">
        <span class="fm-mr-10" style="color: var(--fm-primary-text-color)"
          >购买数量</span
        >
        <CommodityQuantityInputBox
          v-model="nowQuantity"
          label="数量"
          size="small"
          :max="1000"
          @change="
            (e) => {
              changeItemQuantityFromList(e, {
                commoditySpecId: nowCommoditySpec.id,
              });
            }
          "
          v-if="nowCommoditySpec"
        ></CommodityQuantityInputBox>
        <CommodityQuantityInputBox
          v-model="nowQuantity"
          label="数量"
          size="small"
          :min="0"
          :max="1000"
          @change="
            (e) => {
              changeItemQuantityFromList(e, { saleSuitId: nowSaleSuit.id });
            }
          "
          v-if="nowSaleSuit"
        ></CommodityQuantityInputBox>
        <template v-if="nowCommoditySpec">
          <span class="fm-ml-5" v-fmtype="'info'" style="font-size: 0.8rem">{{
            "当前可用库存 " +
            nowCommoditySpec.availableQuantity +
            ",虚拟库存 " +
            nowCommoditySpec.fictitiousQuantity
          }}</span>
          <span
            class="fm-ml-5"
            v-fmtype="'warning'"
            style="font-size: 0.8rem"
            v-if="!nowCommoditySpec.inProduction"
            >{{ "当前规格已停产,请确认是否继续采购 " }}</span
          >
        </template>
      </el-row>

      <el-row v-if="from == 'CommodityTransferOrder'">
        <span class="fm-mr-10" style="color: var(--fm-primary-text-color)"
          >调出数量</span
        >
      </el-row>
      <el-table
        :data="orderWareHouseAddNewPojoList || []"
        stripe
        :row-key="
          (row) => {
            return row.itemNo;
          }
        "
        style="width: 100%"
        :key="'orderWareHouse' + orderWareHouseKey"
        v-if="
          from == 'CommodityTransferOrder' &&
          nowCommoditySpec &&
          nowCommoditySpec.commoditySpecWareHouseList.length > 0
        "
      >
        <el-table-column
          label="仓库"
          min-width="210"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <template
              v-if="nowCommoditySpec.commoditySpecWareHouseList.length > 0"
            >
              <el-select
                :value="scope.row.wareHouseId"
                placeholder="请选择仓库"
                @change="
                  (value) => selectWareHousePopupConfirm(value, scope.$index)
                "
              >
                <el-option
                  v-for="(
                    item, index
                  ) in nowCommoditySpec.commoditySpecWareHouseList.map((d) => {
                    return {
                      label: d.wareHouse.name,
                      wareHouse: d.wareHouse,
                      wareHouseId: d.wareHouseId,
                      fictitiousQuantity: d.fictitiousQuantity,
                      availableQuantity: d.availableQuantity,
                      desc: '虚拟库存 ' + d.fictitiousQuantity,
                    };
                  })"
                  :key="item.wareHouseId + index"
                  :label="item.label"
                  :value="item.wareHouseId"
                >
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    item.desc
                  }}</span>
                </el-option>
              </el-select>
            </template>
            <div style="text-align: left" v-else>
              <span>{{ scope.row.wareHouse.name }}</span>
            </div>
            <div style="text-align: left">
              <span v-if="scope.row.wareHouse">
                {{ "虚拟库存 " + scope.row.fictitiousQuantity }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="调出数量"
          min-width="190"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <CommodityQuantityInputBox
              v-model="scope.row.itemQuantity"
              size="small"
              style="width: 180px"
              @change="specWareHouseNowQuantityChange(scope.$index, scope.row)"
            ></CommodityQuantityInputBox>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="150"
          v-if="canSelectWareHouseListBySpec(nowCommoditySpec).length > 1"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="addSpecWareHouseItem(scope.$index)"
              type="text"
              icon="el-icon-plus"
              :disabled="
                orderWareHouseAddNewPojoList.length ==
                canSelectWareHouseListBySpec(nowCommoditySpec).length
              "
            >
              增加
            </el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              v-fmtype="
                orderWareHouseAddNewPojoList.length == 1 ? 'info' : 'error'
              "
              :disabled="orderWareHouseAddNewPojoList.length == 1"
              @click.native.stop="deleteSpecWareHouseItem(scope.$index)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div
        class="fm-flex fm-mt-10"
        v-if="
          from == 'CommodityTransferOrder' &&
          nowCommoditySpec &&
          nowCommoditySpec.commoditySpecWareHouseList.length > 0
        "
      >
        <span class="fm-mr-10" style="color: var(--fm-primary-text-color)"
          >调入仓库</span
        >
        <el-select
          :value="inWareHouseId"
          placeholder="请选择仓库"
          @change="(value) => selectWareHousePopupConfirmTransferIn(value)"
        >
          <el-option
            v-for="(item, index) in canSelectWareHouseListBySpec(
              nowCommoditySpec
            )"
            :key="item.wareHouseId + index"
            :label="item.label"
            :value="item.wareHouseId"
          >
            <span style="float: left">{{ item.label }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{
              item.desc
            }}</span>
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="selectCommodityPopupShow = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="!((nowCommoditySpec || nowSaleSuit) && nowQuantity > 0)"
          @click="selectCommoditySpec"
        >
          确认选择
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCommoditySelectDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    from: {
      // 来源，SaleOrder 销售单|PurchaseOrder 采购单 | CommodityLossOrder 报损单 | CommodityTransferOrder 调拨单
      type: String,
      default: null,
      require: true,
    },
    supplierId: {
      type: String,
      default: null,
    },
    selectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    show: {
      handler(newVal) {
        this.searchLoading = this.$options.data().searchLoading;
        this.searchData = this.$options.data().searchData;
        this.commodityCategory = this.$options.data().commodityCategory;
        this.searchParam = this.$options.data().searchParam;
        this.searchRes = this.$options.data().searchRes;
        if (this.from == "PurchaseOrder") {
          this.searchParam.supplierId = this.supplierId;
        }
        if (this.show) {
          this.search(true);
          if (this.from == "CommodityTransferOrder") {
            this.getCanSelectWareHouseList();
          }
        }
      },
      immediate: true,
    },
  },

  computed: {
    popupSubTitle() {
      let res = {
        title: "请选择规格或套装",
        type: "",
        text: "",
      };
      if (this.nowCommoditySpec && this.nowCommoditySpec.id) {
        res.title = "规格：";
        res.text = this.nowCommoditySpec.specName;
        res.type = "";
      } else if (this.nowSaleSuit && this.nowSaleSuit.id) {
        res.title = "套装：";
        res.text = this.nowSaleSuit.name;
        res.type = "";
      } else {
        res.title = "请选择规格或套装";
        res.type = "warning";
      }
      return res;
    },
    canSelectSaleSuitList() {
      if (this.nowCommodity) {
        let saleSuitList = this.nowCommodity.commoditySaleSuitList.filter(
          (d) => !d.frozen
        );
        let res = [];
        return saleSuitList
          .map((d) => {
            let commoditySaleSuitItemList = d.commoditySaleSuitItemList;
            let someNotInProduction = false;
            let maxSelectCount = 0;
            let canSelect = true;
            let desc = "";
            let type = "primary";
            if (this.from == "SaleOrder") {
              desc += " ￥" + Number(d.salePrice).toFixed(2);
            }
            let saleSuitSpecIdList = commoditySaleSuitItemList.map(
              (f) => f.commoditySpecId
            );
            let specList = this.nowCommodity.commoditySpecList.filter(
              (f) => saleSuitSpecIdList.indexOf(f.id) > -1
            );

            if (this.from == "PurchaseOrder") {
              let saleSuitRetailPrice = this.$jsTool.sum(
                specList.map((d) =>
                  this.$jsTool.multi(
                    d.retailPrice,
                    commoditySaleSuitItemList.filter(
                      (f) => f.commoditySpecId == d.id
                    )[0].quantity
                  )
                )
              );
              desc += " ￥" + Number(saleSuitRetailPrice).toFixed(2);
            }

            maxSelectCount = commoditySaleSuitItemList
              .map((f) => {
                let spec = specList.filter((g) => f.commoditySpecId == g.id)[0];
                return Math.floor(spec.availableQuantity / f.quantity);
              })
              .sort()[0];
            if (specList.length != saleSuitSpecIdList.length) {
              type = "info";
              canSelect = false;
              desc += "（包含无效规格）";
            } else if (specList.some((f) => f.frozen)) {
              type = "info";
              canSelect = false;
              desc += "（包含已冻结规格）";
            } else if (specList.some((d) => !d.inProduction)) {
              type = "warning";
              desc += "（部分已停产）";
              someNotInProduction = true;
            }
            if (
              this.from == "SaleOrder" ||
              this.from == "CommodityLossOrder" ||
              this.from == "CommodityTransferOrder"
            ) {
              let cantSelectSpecList = [];
              commoditySaleSuitItemList.forEach((j) => {
                let spec = specList.filter((g) => j.commoditySpecId == g.id)[0];
                if (!spec.inProduction && spec.availableQuantity < j.quantity) {
                  cantSelectSpecList.push(spec);
                }
              });
              if (cantSelectSpecList.length > 0) {
                type = "info";
                canSelect = false;
                desc +=
                  "（规格" +
                  cantSelectSpecList.map((a) => a.specName).join("、") +
                  "可用库存小于套装内规格数量）";
              }
            } else {
              let cantSelectSpecList = [];
              commoditySaleSuitItemList.forEach((j) => {
                let spec = specList.filter((g) => j.commoditySpecId == g.id)[0];
                if (!spec.inProduction) {
                  cantSelectSpecList.push(spec);
                }
              });
              if (cantSelectSpecList.length > 0) {
                type = "info";
                canSelect = false;
                desc +=
                  "（规格" +
                  cantSelectSpecList.map((a) => a.specName).join("、") +
                  "已停产）";
              }
            }
            return {
              ...d,
              label: d.name + desc,
              type: type,
              canSelect: canSelect,
              someNotInProduction: someNotInProduction,
              maxSelectCount: maxSelectCount,
              desc: commoditySaleSuitItemList
                .map((f) => {
                  let spec = specList.filter(
                    (g) => f.commoditySpecId == g.id
                  )[0];
                  return spec.specName + " x " + f.quantity;
                })
                .join("；"),
              commoditySaleSuitItemList: commoditySaleSuitItemList.map((f) => {
                let spec = specList.filter((g) => f.commoditySpecId == g.id)[0];
                return {
                  ...f,
                  commoditySpec: spec,
                };
              }),
            };
          })
          .sort((a, b) => {
            if (a.canSelect != b.canSelect) {
              return b.canSelect - a.canSelect;
            }
            return a.name - b.name;
          });
      }
    },
    canSelectSpecList() {
      if (this.nowCommodity) {
        let specList = this.nowCommodity.commoditySpecList.filter(
          (d) => !d.frozen
        );
        return specList
          .map((d) => {
            let type = "primary";
            if (!d.inProduction) {
              type = d.availableQuantity <= 0 ? "info" : "danger";
            }
            let desc = "";
            if (this.from == "SaleOrder") {
              desc += " ￥" + Number(d.buyingPrice).toFixed(2);
              if (!d.inProduction) {
                desc +=
                  d.availableQuantity <= 0 ? " (已停产且已售空)" : " (已停产)";
              }
            } else if (this.from == "PurchaseOrder") {
              desc += " ￥" + Number(d.retailPrice).toFixed(2);
              if (!d.inProduction) {
                desc += " (已停产)";
              }
              type = "warning";
            } else if (this.from == "CommodityLossOrder") {
              if (!d.inProduction) {
                desc += " (已停产)";
              }
            }
            return {
              ...d,
              label: d.specName + desc,
              type: type,
              canSale: d.inProduction || d.availableQuantity > 0,
            };
          })
          .sort((a, b) => {
            if (a.canSale != b.canSale) {
              return b.canSale - a.canSale;
            }
            if (a.inProduction != b.inProduction) {
              return b.inProduction - a.inProduction;
            }
            return a.name - b.name;
          });
      }
      return [];
    },
  },
  data() {
    return {
      searchLoading: false,
      searchData: {
        searchInputValue: null,
        commodityCategoryIdList: null,
        productionStatusEnumList: null,
      },

      commodityCategory: {},

      searchParam: {
        quickSearchInfoList: [
          {
            columns: ["name", "color", "unit", "specName", "specBarCode"],
            quickSearchValue: null,
          },
        ],
        supplierId: null,
        commodityCategoryIdList: [],
        productionStatusEnumList: [],
        pageInfo: {
          page: 1,
          pageSize: 20,
        },
        sortInfo: null,
      },
      searchRes: {},

      // 当前选择的商品
      nowCommodity: {
        imageNameList: [],
        commoditySpecList: [{}],
        commoditySaleSuitList: [],
      },
      // 当前选择的销售套装
      nowSaleSuit: null,
      // 当前选择的商品规格
      nowCommoditySpec: null,
      // 当前选择的商品数量
      nowQuantity: 1,
      // 选择的仓库信息
      orderWareHouseAddNewPojoList: [],

      selectCommodityPopupShow: false,
      orderWareHouseKey: "null",

      selectWareHousePopupIndex: -1,
      wareHouseList: [],

      canSelectWareHouseList: [],
      wareHouseListTransferIn: [],
      inWareHouse: {},
      inWareHouseId: {},

    };
  },

  mounted() {},

  methods: {
    async getCanSelectWareHouseList(args) {
      let res = await this.$api.wareHouse_findListForSelect(args);
      if (res && res.success) {
        this.canSelectWareHouseList = res.data;
      }
    },
    canSelectWareHouseListBySpec(commoditySpec) {
      if (
        !commoditySpec ||
        !commoditySpec.commoditySpecWareHouseList ||
        commoditySpec.commoditySpecWareHouseList.length == 0
      ) {
        return [];
      }
      let res = commoditySpec.commoditySpecWareHouseList.map((d) => {
        return {
          label: d.wareHouse.name,
          wareHouse: d.wareHouse,
          wareHouseId: d.wareHouseId,
          fictitiousQuantity: d.fictitiousQuantity,
          availableQuantity: d.availableQuantity,
          desc: "虚拟库存 " + d.fictitiousQuantity,
        };
      });
      let oldIdList = res.map((d) => d.wareHouseId);
      if (
        this.canSelectWareHouseList &&
        this.canSelectWareHouseList.length > 0
      ) {
        res = res.concat(
          this.canSelectWareHouseList
            .filter((d) => oldIdList.indexOf(d.id) < 0)
            .map((d) => {
              return {
                label: d.name,
                wareHouse: d,
                wareHouseId: d.id,
                fictitiousQuantity: 0,
                availableQuantity: 0,
                desc: "该仓库中没有此规格",
              };
            })
        );
      }
      return res;
    },
    // 调拨单选择调入仓库
    selectWareHousePopupConfirmTransferIn(item) {
      if (!item) {
        return;
      }
      let data = this.canSelectWareHouseListBySpec(
        this.nowCommoditySpec
      ).filter((d) => d.wareHouseId && d.wareHouseId == item)[0];
      this.inWareHouseId = data.wareHouseId;
      this.inWareHouse = data.wareHouse;
    },
    // 报损单选择仓库
    selectWareHousePopupConfirm(item, selectWareHousePopupIndex) {
      if (!item) {
        return;
      }
      let selectIndex = this.orderWareHouseAddNewPojoList.findIndex(
        (d) => d.wareHouseId && d.wareHouseId == item
      );
      if (selectIndex > -1) {
        this.$message.error("请勿重复选择仓库");
        return;
      }
      let data = this.canSelectWareHouseListBySpec(
        this.nowCommoditySpec
      ).filter((d) => d.wareHouseId && d.wareHouseId == item)[0];
      this.orderWareHouseAddNewPojoList.splice(selectWareHousePopupIndex, 1, {
        ...this.orderWareHouseAddNewPojoList[selectWareHousePopupIndex],
        wareHouse: data.wareHouse,
        wareHouseId: data.wareHouseId,
        fictitiousQuantity: data.fictitiousQuantity,
        availableQuantity: data.availableQuantity,
      });
      this.orderWareHouseKey = Math.random();
    },
    specWareHouseNowQuantityChange() {
      this.nowQuantity = Number(
        this.$jsTool.sumQuantity(
          this.orderWareHouseAddNewPojoList.map((d) => d.itemQuantity || 0)
        )
      );
    },
    addSpecWareHouseItem(index) {
      this.orderWareHouseAddNewPojoList.splice(index + 1, 0, {
        itemNo:
          this.orderWareHouseAddNewPojoList[
            this.orderWareHouseAddNewPojoList.length - 1
          ].itemNo + 1,
        itemQuantity: 1,
      });
      this.specWareHouseNowQuantityChange();
    },
    deleteSpecWareHouseItem(index) {
      let that = this;
      this.$confirm("确认删除所选仓库信息？", "操作提醒", {
        confirmButtonText: "继续删除",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
      })
        .then(() => {
          that.orderWareHouseAddNewPojoList.splice(index, 1);
          that.orderWareHouseKey = Math.random();
          that.specWareHouseNowQuantityChange();
        })
        .catch(() => {});
    },
    showEditSpecPopup(item, index) {
      if (
        this.from != "CommodityLossOrder" &&
        this.from != "CommodityTransferOrder"
      ) {
        return;
      }
      this.nowCommodity = item.commodity;
      this.nowCommoditySpec = item.commoditySpec;
      this.nowQuantity = item.itemQuantity;
      this.orderWareHouseAddNewPojoList =
        this.from == "CommodityLossOrder"
          ? item.orderWareHouseAddNewPojoList
          : item.outWareHouseAddNewPojoList;
      this.selectCommodityPopupShow = true;
    },

    close() {
      this.$emit("close");
    },
    // 已选商品的价格详情
    getAmountLabel(item) {
      if (item.saleSuitId) {
        return;
      }
      if (this.from == "SaleOrder") {
        return (
          (item.buyingPrice || item.commoditySpec.buyingPrice) +
          " * " +
          item.itemQuantity +
          (item.disCountAmount == 0 ? "" : " - " + item.disCountAmount) +
          " = " +
          item.itemAmount
        );
      } else if (this.from == "PurchaseOrder") {
        return (
          (item.retailPrice || item.commoditySpec.retailPrice) +
          " * " +
          item.itemQuantity +
          (item.disCountAmount == 0 ? "" : " - " + item.disCountAmount) +
          " = " +
          item.itemAmount
        );
      }
    },
    // 查看已选商品时的金额提醒
    showSaleSuitTips(itemList) {
      if (this.from == "SaleOrder") {
        this.$tool.showTipsModal(
          "套装金额详情",
          "套装售价：" +
            Number(itemList[0].saleSuitSalePrice).toFixed(2) +
            "\n" +
            "数量：" +
            itemList[0].saleSuitQuantity +
            "\n" +
            "折扣金额：" +
            itemList[0].saleSuitDisCountAmount +
            "\n" +
            "金额合计：" +
            this.$jsTool.sum(itemList.map((f) => f.itemAmount)) +
            "\n" +
            "计算公式：" +
            Number(itemList[0].saleSuitSalePrice).toFixed(2) +
            " * " +
            itemList[0].saleSuitQuantity +
            " - " +
            itemList[0].saleSuitDisCountAmount +
            " = " +
            this.$jsTool.sum(itemList.map((f) => f.itemAmount))
        );
      } else if (this.from == "PurchaseOrder") {
        this.$tool.showTipsModal(
          "套装金额详情",
          "套装采购价：" +
            Number(itemList[0].saleSuitRetailPrice).toFixed(2) +
            "\n" +
            "数量：" +
            itemList[0].saleSuitQuantity +
            "\n" +
            "折扣金额：" +
            itemList[0].saleSuitDisCountAmount +
            "\n" +
            "金额合计：" +
            this.$jsTool.sum(itemList.map((f) => f.itemAmount)) +
            "\n" +
            "计算公式：" +
            Number(itemList[0].saleSuitRetailPrice).toFixed(2) +
            " * " +
            itemList[0].saleSuitQuantity +
            " - " +
            itemList[0].saleSuitDisCountAmount +
            " = " +
            this.$jsTool.sum(itemList.map((f) => f.itemAmount))
        );
      }
    },
    showAmountTips(item) {
      this.$jsTool.showTipsModal(
        "金额详情",
        (this.from == "SaleOrder" ? "零售价：" : "采购价：") +
          (this.from == "SaleOrder"
            ? Number(
                item.buyingPrice || item.commoditySpec.buyingPrice
              ).toFixed(2)
            : Number(
                item.retailPrice || item.commoditySpec.retailPrice
              ).toFixed(2)) +
          "\n" +
          "数量：" +
          item.itemQuantity +
          "\n" +
          "折扣金额：" +
          item.disCountAmount +
          "\n" +
          "金额合计：" +
          item.itemAmount +
          "\n" +
          "计算公式：" +
          (this.from == "SaleOrder"
            ? Number(
                item.buyingPrice || item.commoditySpec.buyingPrice
              ).toFixed(2)
            : Number(
                item.retailPrice || item.commoditySpec.retailPrice
              ).toFixed(2)) +
          " * " +
          item.itemQuantity +
          " - " +
          item.disCountAmount +
          " = " +
          item.itemAmount
      );
    },
    async selectCommodity(item) {
      this.nowCommodity = {
        ...item,
        commoditySpecList: [],
        commoditySaleSuitList: [],
      };
      this.selectCommodityPopupShow = true;
      let findCommodityVoRes = await this.$api.commodity_findVoById(item.id, {
        showLoading: true,
        loadingParam: {
          target: "#selectCommodityPopup > *",
          lock: true,
        },
      });
      if (findCommodityVoRes && findCommodityVoRes.success) {
        this.nowCommodity = {
          ...findCommodityVoRes.data.commodity,
          commoditySpecList: findCommodityVoRes.data.commoditySpecList,
          commoditySaleSuitList:
            findCommodityVoRes.data.commoditySaleSuitList || [],
        };
      }
      this.nowSaleSuit = null;
      this.nowCommoditySpec = null;
      this.inWareHouse = null;
      this.inWareHouseId = null;
      let index = this.selectList.findIndex((d) => d.commodityId == item.id);
      if (index > -1) {
        // 优先判断套装
        if (this.selectList[index].saleSuitId) {
          this.nowSaleSuit = this.canSelectSaleSuitList.filter(
            (d) => d.id == this.selectList[index].saleSuitId
          )[0];
          this.nowQuantity = this.selectList[index].saleSuitQuantity;
        } else {
          this.nowCommoditySpec = this.canSelectSpecList.filter(
            (d) => d.id == this.selectList[index].commoditySpecId
          )[0];
          this.nowQuantity = this.selectList[index].itemQuantity;
          if (this.from == "CommodityTransferOrder") {
            this.orderWareHouseAddNewPojoList =
              this.selectList[index].outWareHouseAddNewPojoList;
            this.inWareHouse = this.selectList[index].inWareHouse;
            this.inWareHouseId = this.selectList[index].inWareHouseId;
          }
        }
      } else {
        if (
          (this.canSelectSpecList && this.canSelectSpecList.length > 0) ||
          (this.canSelectSaleSuitList && this.canSelectSaleSuitList.length > 0)
        ) {
          // this.nowCommoditySpec = this.canSelectSpecList[0];
          this.nowQuantity = 1;
        } else {
          this.$message.error("此商品下没有可选择的套装及规格,请选择其他商品");
          return;
        }
      }
    },

    // 点击销售套装tag
    clickSaleSuitTag(item) {
      if (!item.canSelect) {
        this.$message.error("当前销售套装不可选择");
        return;
      }
      this.nowSaleSuit = item;
      this.nowCommoditySpec = null;
      let index = this.selectList.findIndex((d) => d.saleSuitId == item.id);
      if (index > -1) {
        this.nowQuantity = this.selectList[index].saleSuitQuantity;
      } else {
        this.nowQuantity = 1;
      }
    },
    // 点击商品规格tag
    clickCommoditySpecTag(item) {
      if (this.from == "SaleOrder") {
        if (!item.canSale) {
          this.$message.error("所选规格已全部停产且已全部售空,请选择其他商品");
          return;
        }
      } else if (this.from == "PurchaseOrder") {
        if (!item.inProduction) {
          this.$message.error("所选规格已停产,请确认是否继续采购此规格");
        }
      }
      this.nowSaleSuit = null;
      this.nowCommoditySpec = item;
      this.inWareHouse = null;
      this.inWareHouseId = null;
      let index = this.selectList.findIndex(
        (d) => !d.saleSuitId && d.commoditySpecId == item.id
      );
      if (index > -1) {
        this.nowQuantity = this.selectList[index].itemQuantity;
        if (this.from == "CommodityTransferOrder") {
          this.orderWareHouseAddNewPojoList =
            this.selectList[index].outWareHouseAddNewPojoList;
          this.inWareHouse = this.selectList[index].inWareHouse;
          this.inWareHouseId = this.selectList[index].inWareHouseId;
        }
      } else {
        this.nowQuantity = 1;
        if (this.from == "CommodityTransferOrder") {
          // 只有一个则默认选择
          let specWareHouse =
            item.commoditySpecWareHouseList.length == 1
              ? item.commoditySpecWareHouseList[0]
              : {};
          this.orderWareHouseAddNewPojoList = [
            {
              itemNo: 1,
              wareHouse: specWareHouse.wareHouse || null,
              wareHouseId: specWareHouse.wareHouseId || null,
              fictitiousQuantity: specWareHouse.fictitiousQuantity || 0,
              availableQuantity: specWareHouse.availableQuantity || 0,
              itemQuantity: 1,
            },
          ];
        }
      }
    },
    // 选择商品规格
    selectCommoditySpec() {
      try {
        if (!this.nowCommodity || !this.nowCommodity.id) {
          this.$message.error("请选择商品");
          return;
        }
        if (
          (!this.nowCommoditySpec || !this.nowCommoditySpec.id) &&
          (!this.nowSaleSuit || !this.nowSaleSuit.id)
        ) {
          this.$message.error("请选择规格或套装");
          return;
        }
        if (!this.nowQuantity || this.nowQuantity < 0) {
          this.$message.error("请输入数量");
          return;
        }
        if (this.from == "CommodityTransferOrder") {
          if (
            this.orderWareHouseAddNewPojoList.length == 0 ||
            this.orderWareHouseAddNewPojoList.findIndex((f) => !f.wareHouseId) >
              -1
          ) {
            this.$message.error("请选择仓库及填写调拨数量");
            return;
          }
          if (!this.inWareHouse || !this.inWareHouseId) {
            this.$message.error("请选择调入仓库");
            return;
          }
        }
        let that = this;
        if (this.nowCommoditySpec && this.nowCommoditySpec.id) {
          if (this.from == "SaleOrder") {
            if (!this.nowCommoditySpec.canSale) {
              this.$message.error(
                "所选规格已全部停产且已全部售空,请选择其他商品"
              );
              return;
            }
            if (
              !this.nowCommoditySpec.inProduction &&
              this.nowQuantity > this.nowCommoditySpec.availableQuantity
            ) {
              this.$message.error(
                "所选数量 " +
                  this.nowQuantity +
                  " 超出规格可用库存 " +
                  this.nowCommoditySpec.availableQuantity
              );
              return;
            }
            let index = this.selectList.findIndex(
              (d) =>
                !d.saleSuitId && d.commoditySpecId == this.nowCommoditySpec.id
            );
            let itemNo =
              index > -1
                ? this.selectList[index].itemNo
                : this.selectList && this.selectList.length > 0
                ? this.selectList[this.selectList.length - 1].itemNo + 1
                : 1;
            let itemAmount = this.$jsTool.multi(
              this.nowCommoditySpec.buyingPrice,
              this.nowQuantity
            );
            console.log("itemAmount", itemAmount);
            console.log("itemAmount", this.$jsTool.toFixed(itemAmount, 2));
            let item = {
              buyingPrice: this.nowCommoditySpec.buyingPrice,
              itemNo: itemNo,
              commodityId: this.nowCommodity.id,
              commodity: this.nowCommodity,
              commoditySpecId: this.nowCommoditySpec.id,
              commoditySpec: this.nowCommoditySpec,
              itemQuantity: this.nowQuantity,
              commodityBuyingTotalAmount: itemAmount,
              disCountAmount: 0,
              itemAmount: itemAmount,
            };
            if (index > -1) {
              let res = this.selectList;
              res.splice(index, 1, item);
              this.confirmSelect(res);
            } else {
              this.confirmSelect(this.selectList.concat(item));
            }
            // this.selectCommodityPopupShow = false;
          } else if (this.from == "PurchaseOrder") {
            if (that.nowCommoditySpec.inProduction) {
              let index = that.selectList.findIndex(
                (d) =>
                  !d.saleSuitId && d.commoditySpecId == that.nowCommoditySpec.id
              );
              let itemNo =
                index > -1
                  ? that.selectList[index].itemNo
                  : that.selectList && that.selectList.length > 0
                  ? that.selectList[that.selectList.length - 1].itemNo + 1
                  : 1;
              let itemAmount = that.$jsTool.multi(
                that.nowCommoditySpec.retailPrice,
                that.nowQuantity
              );
              let item = {
                itemNo: itemNo,
                retailPrice: that.nowCommoditySpec.retailPrice,
                commodityId: that.nowCommodity.id,
                commodity: that.nowCommodity,
                commoditySpecId: that.nowCommoditySpec.id,
                commoditySpec: that.nowCommoditySpec,
                itemQuantity: that.nowQuantity,
                commodityRetailTotalAmount: itemAmount,
                disCountAmount: 0,
                itemAmount: itemAmount,
              };
              if (index > -1) {
                let res = that.selectList;
                res.splice(index, 1, item);
                that.confirmSelect(res);
              } else {
                that.confirmSelect(that.selectList.concat(item));
              }
              //   that.selectCommodityPopupShow = false;
            } else {
              this.$confirm("所选规格已停产，是否继续采购此规格", "操作提醒", {
                confirmButtonText: "继续",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                closeOnHashChange: false,
              }).then(() => {
                try {
                  let index = that.selectList.findIndex(
                    (d) =>
                      !d.saleSuitId &&
                      d.commoditySpecId == that.nowCommoditySpec.id
                  );
                  let itemNo =
                    index > -1
                      ? that.selectList[index].itemNo
                      : that.selectList && that.selectList.length > 0
                      ? that.selectList[that.selectList.length - 1].itemNo + 1
                      : 1;
                  let itemAmount = that.$jsTool.multi(
                    that.nowCommoditySpec.retailPrice,
                    that.nowQuantity
                  );
                  let item = {
                    itemNo: itemNo,
                    retailPrice: that.nowCommoditySpec.retailPrice,
                    commodityId: that.nowCommodity.id,
                    commodity: that.nowCommodity,
                    commoditySpecId: that.nowCommoditySpec.id,
                    commoditySpec: that.nowCommoditySpec,
                    itemQuantity: that.nowQuantity,
                    commodityRetailTotalAmount: itemAmount,
                    disCountAmount: 0,
                    itemAmount: itemAmount,
                  };
                  if (index > -1) {
                    // that.selectList.splice(index, 1, item);
                    that.confirmSelect(that.selectList.slice(index, 1, item));
                  } else {
                    // that.selectList.push(item);
                    that.confirmSelect(that.selectList.concat(item));
                  }
                  //   that.selectCommodityPopupShow = false;
                } finally {
                }
              });
            }
          } else if (this.from == "CommodityLossOrder") {
            let index = this.selectList.findIndex(
              (d) => d.commoditySpecId == this.nowCommoditySpec.id
            );
            let itemNo =
              index > -1
                ? this.selectList[index].itemNo
                : this.selectList && this.selectList.length > 0
                ? this.selectList[this.selectList.length - 1].itemNo + 1
                : 1;
            let item = {
              itemNo: itemNo,
              commodityId: this.nowCommodity.id,
              commodity: this.nowCommodity,
              commoditySpecId: this.nowCommoditySpec.id,
              commoditySpec: this.nowCommoditySpec,
              itemQuantity: this.nowQuantity,
              orderWareHouseAddNewPojoList: this.orderWareHouseAddNewPojoList,
            };
            if (index > -1) {
              let res = that.selectList;
              res.splice(index, 1, item);
              this.confirmSelect(res);
            } else {
              this.confirmSelect(this.selectList.concat(item));
            }
          } else if (this.from == "CommodityTransferOrder") {
            let index = this.selectList.findIndex(
              (d) => d.commoditySpecId == this.nowCommoditySpec.id
            );
            let itemNo =
              index > -1
                ? this.selectList[index].itemNo
                : this.selectList && this.selectList.length > 0
                ? this.selectList[this.selectList.length - 1].itemNo + 1
                : 1;
            let item = {
              itemNo: itemNo,
              commodityId: this.nowCommodity.id,
              commodity: this.nowCommodity,
              commoditySpecId: this.nowCommoditySpec.id,
              commoditySpec: this.nowCommoditySpec,
              itemQuantity: this.nowQuantity,
              outWareHouseAddNewPojoList: this.orderWareHouseAddNewPojoList,
              inWareHouse: this.inWareHouse,
              inWareHouseId: this.inWareHouseId,
            };
            if (index > -1) {
              let res = this.selectList;
              res.splice(index, 1, item);
              this.confirmSelect(res);
            } else {
              this.confirmSelect(this.selectList.concat(item));
            }
          }
        } else {
          if (this.from == "SaleOrder") {
            if (!this.nowSaleSuit.canSelect) {
              this.$message.error("当前销售套装不可选择");
              return;
            }
            if (
              this.nowSaleSuit.someNotInProduction &&
              this.nowQuantity > this.nowSaleSuit.maxSelectCount
            ) {
              this.$message.error(
                "所选数量 " +
                  this.nowQuantity +
                  " 超出套装最大可选数量 " +
                  this.nowSaleSuit.maxSelectCount
              );
              return;
            }
            let selectSpecList = this.selectList.filter(
              (d) => d.saleSuitId && d.saleSuitId == this.nowSaleSuit.id
            );
            let totalSalePrice = this.$jsTool.multi(
              this.nowSaleSuit.salePrice,
              this.nowQuantity
            );
            let totalBuyingAmount = this.$jsTool.sum(
              this.nowSaleSuit.commoditySaleSuitItemList.map((d) =>
                this.$jsTool.multi(
                  d.commoditySpec.buyingPrice,
                  this.$jsTool.multi(d.quantity, this.nowQuantity)
                )
              )
            );
            if (!selectSpecList || selectSpecList.length == 0) {
              let minItemNo =
                this.selectList && this.selectList.length > 0
                  ? this.selectList[this.selectList.length - 1].itemNo + 1
                  : 1;
              let res = [];
              this.nowSaleSuit.commoditySaleSuitItemList.forEach(
                (item, index) => {
                  let itemQuantity = Number(
                    this.$jsTool.multi(this.nowQuantity, item.quantity)
                  );
                  let itemTotalBuyingAmount = this.$jsTool.multi(
                    item.commoditySpec.buyingPrice,
                    itemQuantity
                  );
                  let itemAmount = 0;
                  if (
                    index ==
                    this.nowSaleSuit.commoditySaleSuitItemList.length - 1
                  ) {
                    itemAmount = this.$jsTool.sub(
                      totalSalePrice,
                      this.$jsTool.sum(
                        res
                          .filter(
                            (d) =>
                              d.saleSuitId &&
                              d.saleSuitId == this.nowSaleSuit.id &&
                              d.commoditySpecId != item.commoditySpecId
                          )
                          .map((f) => f.itemAmount)
                      )
                    );
                  } else {
                    itemAmount = this.$jsTool.multi(
                      itemTotalBuyingAmount,
                      this.$jsTool.divis(totalSalePrice, totalBuyingAmount, 8)
                    );
                  }
                  res.push({
                    itemNo: minItemNo + index,
                    commodityId: this.nowCommodity.id,
                    commodity: this.nowCommodity,
                    commoditySpecId: item.commoditySpec.id,
                    commoditySpec: item.commoditySpec,
                    saleSuitId: this.nowSaleSuit.id,
                    saleSuit: this.nowSaleSuit,
                    saleSuitName: this.nowSaleSuit.name,
                    saleSuitSalePrice: this.nowSaleSuit.salePrice,
                    saleSuitQuantity: this.nowQuantity,
                    saleSuitItemQuantity: item.quantity,
                    saleSuitSumAmount: totalSalePrice,
                    saleSuitDisCountAmount: "0.00",
                    saleSuitAmount: totalSalePrice,
                    itemQuantity: itemQuantity,
                    commodityBuyingTotalAmount: itemTotalBuyingAmount,
                    disCountAmount: this.$jsTool.sub(
                      itemTotalBuyingAmount,
                      itemAmount
                    ),
                    itemAmount: itemAmount,
                    buyingPrice: item.commoditySpec.buyingPrice,
                  });
                }
              );
              console.log("res", res);
              this.confirmSelect(this.selectList.concat(res));
            } else {
              selectSpecList.forEach((item, index) => {
                let selectIndex = that.selectList.findIndex(
                  (d) =>
                    d.saleSuitId &&
                    d.saleSuitId == that.nowSaleSuit.id &&
                    d.commoditySpecId == item.commoditySpec.id
                );
                let itemQuantity = Number(
                  that.$jsTool.multi(
                    that.nowQuantity,
                    item.saleSuitItemQuantity
                  )
                );
                let itemTotalBuyingAmount = that.$jsTool.multi(
                  item.commoditySpec.buyingPrice,
                  itemQuantity
                );
                let itemAmount = 0;
                if (index == selectSpecList.length - 1) {
                  itemAmount = that.$jsTool.sub(
                    totalSalePrice,
                    that.$jsTool.sum(
                      that.selectList
                        .filter(
                          (d) =>
                            d.saleSuitId &&
                            d.saleSuitId == that.nowSaleSuit.id &&
                            d.commoditySpecId != item.commoditySpecId
                        )
                        .map((f) => f.itemAmount)
                    )
                  );
                } else {
                  itemAmount = that.$jsTool.multi(
                    itemTotalBuyingAmount,
                    that.$jsTool.divis(totalSalePrice, totalBuyingAmount, 8)
                  );
                }
                let res = that.selectList;
                res.splice(selectIndex, 1, {
                  ...that.selectList[selectIndex],
                  saleSuitSalePrice: that.nowSaleSuit.salePrice,
                  saleSuitQuantity: that.nowQuantity,
                  saleSuitSumAmount: totalSalePrice,
                  saleSuitDisCountAmount: "0.00",
                  saleSuitAmount: totalSalePrice,
                  itemQuantity: itemQuantity,
                  commodityBuyingTotalAmount: itemTotalBuyingAmount,
                  disCountAmount: that.$jsTool.sub(
                    itemTotalBuyingAmount,
                    itemAmount
                  ),
                  itemAmount: itemAmount,
                });
                that.confirmSelect(res);
              });
            }
          } else if (this.from == "PurchaseOrder") {
            if (!this.nowSaleSuit.canSelect) {
              this.$message.error("当前销售套装不可选择");
              return;
            }
            let selectSpecList = this.selectList.filter(
              (d) => d.saleSuitId && d.saleSuitId == this.nowSaleSuit.id
            );
            let saleSuitRetailPrice = this.$jsTool.sum(
              this.nowSaleSuit.commoditySaleSuitItemList.map((d) =>
                this.$jsTool.multi(d.commoditySpec.retailPrice, d.quantity)
              )
            );
            let totalRetailPrice = this.$jsTool.multi(
              saleSuitRetailPrice,
              this.nowQuantity
            );
            if (!selectSpecList || selectSpecList.length == 0) {
              let minItemNo =
                this.selectList && this.selectList.length > 0
                  ? this.selectList[this.selectList.length - 1].itemNo + 1
                  : 1;
              let res = [];
              this.nowSaleSuit.commoditySaleSuitItemList.forEach(
                (item, index) => {
                  let itemQuantity = Number(
                    this.$jsTool.multi(this.nowQuantity, item.quantity)
                  );
                  let itemTotalRetailAmount = this.$jsTool.multi(
                    item.commoditySpec.retailPrice,
                    itemQuantity
                  );
                  res.push({
                    itemNo: minItemNo + index,
                    commodityId: this.nowCommodity.id,
                    commodity: this.nowCommodity,
                    commoditySpecId: item.commoditySpec.id,
                    commoditySpec: item.commoditySpec,
                    saleSuitId: this.nowSaleSuit.id,
                    saleSuit: this.nowSaleSuit,
                    saleSuitName: this.nowSaleSuit.name,
                    saleSuitRetailPrice: saleSuitRetailPrice,
                    saleSuitQuantity: this.nowQuantity,
                    saleSuitItemQuantity: item.quantity,
                    saleSuitSumAmount: totalRetailPrice,
                    saleSuitDisCountAmount: "0.00",
                    saleSuitAmount: totalRetailPrice,
                    itemQuantity: itemQuantity,
                    commodityRetailTotalAmount: itemTotalRetailAmount,
                    disCountAmount: "0.00",
                    itemAmount: itemTotalRetailAmount,
                    retailPrice: item.commoditySpec.retailPrice,
                  });
                }
              );
              this.confirmSelect(this.selectList.concat(res));
            } else {
              let res = that.selectList;
              selectSpecList.forEach((item, index) => {
                let selectIndex = that.selectList.findIndex(
                  (d) =>
                    d.saleSuitId &&
                    d.saleSuitId == that.nowSaleSuit.id &&
                    d.commoditySpecId == item.commoditySpec.id
                );
                let itemQuantity = Number(
                  that.$jsTool.multi(
                    that.nowQuantity,
                    item.saleSuitItemQuantity
                  )
                );
                let itemTotalRetailAmount = that.$jsTool.multi(
                  item.commoditySpec.retailPrice,
                  itemQuantity
                );
                res.slice(index, 1, {
                  ...that.selectList[selectIndex],
                  saleSuitRetailPrice: saleSuitRetailPrice,
                  saleSuitQuantity: that.nowQuantity,
                  saleSuitSumAmount: totalRetailPrice,
                  saleSuitDisCountAmount: "0.00",
                  saleSuitAmount: totalRetailPrice,
                  itemQuantity: itemQuantity,
                  commodityRetailTotalAmount: itemTotalRetailAmount,
                  disCountAmount: "0.00",
                  itemAmount: itemTotalRetailAmount,
                });
              });
              that.confirmSelect(res);
            }
          }
        }
      } finally {
      }
    },
    // 确认选择
    confirmSelect(list) {
      let that = this;
      if (!list || list.length == 0) {
        this.$confirm(
          "尚未选择商品，继续确认将会移除单据中原已选择的商品，是否继续？",
          "操作提醒",
          {
            confirmButtonText: "继续确认",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            closeOnHashChange: false,
          }
        )
          .then(() => {
            this.$emit("selectCommodity", list || []);
          })
          .catch(() => {});
      } else {
        this.$emit("selectCommodity", list || []);
      }
    },
    changeItemQuantityFromList(value, { saleSuitId, commoditySpecId }) {
      // 如果index < 0，则代表是新商品，无需进行处理
      if (
        !(
          saleSuitId &&
          this.selectList.findIndex(
            (d) => d.saleSuitId && d.saleSuitId == saleSuitId
          ) > -1
        ) &&
        !(
          commoditySpecId &&
          this.selectList.findIndex(
            (d) => !d.saleSuitId && d.commoditySpecId == commoditySpecId
          ) > -1
        )
      ) {
        return;
      }
      let that = this;
      if (value <= 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            that.nowCommoditySpec = {};
            that.nowSaleSuit = {};
            if (saleSuitId) {
              let selectSpecList = that.selectList.filter(
                (d) => d.saleSuitId && d.saleSuitId == saleSuitId
              );
              selectSpecList.forEach((item, index) => {
                let selectIndex = that.selectList.findIndex(
                  (d) =>
                    d.saleSuitId &&
                    d.saleSuitId == item.saleSuitId &&
                    d.commoditySpecId == item.commoditySpec.id
                );
                that.selectList.splice(selectIndex, 1);
              });
            } else {
              that.selectList.splice(
                that.selectList.findIndex(
                  (d) => !d.saleSuitId && d.commoditySpecId == commoditySpecId
                ),
                1
              );
            }
            that.selectCommodityPopupShow = false;
          })
          .catch(() => {
            that.changeItemQuantityFromList(1, {
              saleSuitId,
              commoditySpecId,
            });
            that.nowQuantity = 1;
          });
      }
    },

    handleSizeChange(val) {
      this.searchParam.pageInfo.pageSize = val;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    handleCurrentChange(val) {
      this.searchParam.pageInfo.page = val;
      this.search(false, {
        showSuccessMessage: true,
      });
    },
    changeAndSearch() {
      this.searchParam.quickSearchInfoList[0].quickSearchValue =
        this.searchData.searchInputValue;
      this.searchParam.commodityCategoryIdList =
        this.searchData.commodityCategoryIdList;
      this.searchParam.productionStatusEnumList =
        this.searchData.productionStatusEnumList;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    resetAndSearch() {
      this.searchData = this.$options.data().searchData;
      this.changeAndSearch();
    },
    sortChange(val) {
      this.searchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    async search(init, args) {
      this.searchLoading = true;
      if (init) {
        this.searchParam.pageInfo.page = 1;
      }
      let requestRes = await this.$api.commodity_findPageForSelect(
        this.searchParam,
        args
      );
      if (requestRes && requestRes.success) {
        this.searchRes = requestRes;
        this.searchRes.pageInfo = requestRes.pageInfo;
        this.$nextTick(() => {
          if (this.$refs.refsTable) {
            this.$refs.refsTable.doLayout();
          }
        });
      }
      if (requestRes.pageCount == 0) {
        this.searchRes = null;
      }
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },
    commodityCategorySelect(item) {
      this.commodityCategory = item;
      this.searchData.commodityCategoryIdList = [item.id];
      this.changeAndSearch();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/CommoditySelectDialog.vue